import Navbar from "@/pages/home/components/Navbar";
import NewsTicker from "@/pages/home/components/NewsTicker";
import Hero from "@/pages/home/components/Hero";
import TodayFeed from "@/pages/home/components/TodayFeed";
import BigCardFlow from "@/pages/home/components/BigCardFlow";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import LiveFeed from "@/pages/home/components/LiveFeed";
import TopicTags from "@/pages/home/components/TopicTags";
import SubscribeForm from "@/pages/home/components/SubscribeForm";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <NewsTicker />
      <main className="flex-1">
        <Hero />
        <TodayFeed />
        <BigCardFlow />
        <CollectionIndex />
        <LiveFeed />
        <TopicTags />
        <SubscribeForm />
      </main>
      <SiteFooter />
    </div>
  );
}